import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageGuard = () => {
    const { i18n } = useTranslation();
    const isInitialized = useRef(false);

    // Set up language listener only once on mount
    useEffect(() => {
        if (isInitialized.current) return;
        isInitialized.current = true;

        // Ensure German is set initially
        if (i18n.language !== 'de') {
            i18n.changeLanguage('de');
        }

        // Listen for any language changes and force German
        const handleLanguageChange = (lng) => {
            if (lng !== 'de') {
                // Prevent infinite loop by checking if we're already changing
                if (!i18n.isInitialized || i18n.language !== 'de') {
                    i18n.changeLanguage('de');
                }
            }
        };

        i18n.on('languageChanged', handleLanguageChange);

        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Only run once on mount - i18n is stable and doesn't need to be in deps

    return null;
};

export default LanguageGuard;

